<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="secondary" v-b-tooltip.hover :title="showToolTip ? 'Экспортировать' : ''"><i class="fa fa-external-link-square"></i></b-button>
</template>

<script>

export default ({
  name: "button-export",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
